// extracted by mini-css-extract-plugin
export default {"container":"CookiesInternal_container__z1Q4A","hiq":"CookiesInternal_hiq__exeXI","background":"CookiesInternal_background__4dlF6"};